import { render, staticRenderFns } from "./Dimension.vue?vue&type=template&id=3cdb39b6&"
import script from "./Dimension.vue?vue&type=script&lang=js&"
export * from "./Dimension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports